//Axios: Peticiones HTTP via Ajax
import axios from 'axios';
//let config   = require('/run/secrets/aspirantes_formulario.json')


export const swal = require('sweetalert2');

export const HTTPFront = axios.create({
  baseURL: '/'
});
export default function getProvinces(countrySelected) {
  HTTPFront.get('/getProvincesByCountry/' + countrySelected.code_iso_alfa3)
    .then(res => {
      this.provinces = res.data;
    })
}

